import { render, staticRenderFns } from "./EducationPlansIndex.vue?vue&type=template&id=7ba7c2d6"
import script from "./EducationPlansIndex.vue?vue&type=script&lang=js"
export * from "./EducationPlansIndex.vue?vue&type=script&lang=js"
import style0 from "./EducationPlansIndex.vue?vue&type=style&index=0&id=7ba7c2d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports